<template>
  <div class="Wrapper">
    <aside class="LeftSidebar">
      <div class="StickyContent">
        <a
          href="https://freecomadsl.com"
          target="_blank"
          rel="noopener"
          class="Nice"
        >
          <img
            src="https://d3mjy69y7ovtnw.cloudfront.net/comisonews/ad/vertical.gif"
            class="NiceVertical"
          />
          <img
            src="https://d3mjy69y7ovtnw.cloudfront.net/comisonews/ad/horizontal.jpg"
            class="NiceHorizontal"
          />
        </a>
      </div>
    </aside>
    <aside class="RightSidebar">
      <h2>Articoli correlati</h2>
      <article-block
        v-for="otherArticle in otherArticles"
        :key="otherArticle.slug.current"
        class="OtherArticle"
        :is-fetching="otherArticlesLoading"
        :article="otherArticle"
        small
      />
    </aside>
    <article class="Content">
      <header class="Header">
        <div class="Details">
          <h3 class="Category">
            {{ article.category.title }}
          </h3>
        </div>
        <h1 class="NoBorder Title">
          {{ article.title }}
        </h1>
        <div class="From">
          <a id="Author" class="WithLine" :href="article.link" target="_blank">
            {{ article.author }}
          </a>
          <img
            class="IconClock"
            src="/assets/icons/clock.svg"
            alt="Icona orologio"
          />
          <span>{{ formatToNow(article.publishedAt) }}</span>
        </div>
      </header>
      <div class="MainImage">
        <VuePureLightbox
          :thumbnail="article.imageUrl"
          :images="[article.imageUrl]"
          :alternate-text="article.title"
        />
      </div>
      <div class="Body" v-html="article.body" />
      <div class="Bottom">
        <h4>Condividi subito l'articolo via:</h4>
        <client-only>
          <social-sharing
            :url="`${baseURL}${$route.path}`"
            :title="`Comiso News - ${article.title}`"
            :description="article.abstract"
            :quote="`${article.title}. Leggi su comisonews.it`"
            :hashtags="`comisonews,${article.category.slug.current}`"
            twitter-user="comisonews"
            inline-template
          >
            <div class="ShareIcons">
              <network network="facebook">
                <icon scale="3" name="brands/facebook" color="#3B5998"></icon>
              </network>
              <network network="twitter">
                <icon
                  scale="3"
                  name="brands/twitter-square"
                  color="#1DA1F2"
                ></icon>
              </network>
              <network network="telegram">
                <icon
                  scale="3"
                  name="brands/telegram-plane"
                  color="#0088cc"
                ></icon>
              </network>
              <network network="whatsapp">
                <icon
                  scale="3"
                  name="brands/whatsapp-square"
                  color="#34af23"
                ></icon>
              </network>
              <network network="email">
                <icon scale="3" name="envelope-square" color="#ff4343"></icon>
              </network>
              <network network="sms">
                <icon scale="3" name="sms" color="#333"></icon>
              </network>
            </div>
          </social-sharing>
        </client-only>
      </div>
    </article>
  </div>
</template>

<script>
import VuePureLightbox from 'vue-pure-lightbox';
import 'vue-pure-lightbox/dist/VuePureLightbox.css';
import ArticleBlock from '~/components/ArticleBlock.vue';
import { CATEGORIES } from '~/lib/consts';
import { fetchNews, fetchRelatedNews } from '~/plugins/sanity';
import { formatToNow } from '~/lib/date';

export default {
  components: {
    ArticleBlock,
    VuePureLightbox,
  },
  async asyncData({ params }) {
    const { slug, category } = params;
    const existingCategory = CATEGORIES[category];
    const article = await fetchNews(slug);
    return { slug, category: existingCategory, article };
  },
  data() {
    return {
      otherArticles: [],
      baseURL: process.env.BASE_URL,
    };
  },
  head() {
    return {
      title: `Comiso News - ${this.article.title}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.article.abstract,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `Comiso News - ${this.article.title}`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.article.abstract,
        },
        {
          hid: 'og:type',
          property: 'og:type',
          content: 'article',
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.article.imageUrl,
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `${process.env.BASE_URL}${this.$route.path}`,
        },
        {
          hid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: `Comiso News - ${this.article.title}`,
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.article.abstract,
        },
        {
          hid: 'twitter:image:src',
          name: 'twitter:image:src',
          content: this.article.imageUrl,
        },
      ],
    };
  },
  computed: {
    otherArticlesLoading() {
      return this.$store.otherArticlesLoading;
    },
  },
  async mounted() {
    this.$store.commit('updateOtherArticlesLoading', true);
    const otherArticles = await fetchRelatedNews(
      this.category.slug,
      this.article._id
    );
    this.otherArticles = otherArticles;
    this.$store.commit('updateOtherArticlesLoading', false);
  },
  methods: {
    formatToNow,
  },
};
</script>

<style lang="postcss" scoped>
@import '~/assets/media.pcss';
@import '~/assets/vars.pcss';
@import '~/assets/typography.pcss';

.LeftSidebar {
  grid-area: left-sidebar;
}

.RightSidebar {
  grid-area: right-sidebar;
}

.Content {
  grid-area: content;
}

.Header {
  grid-area: header;
  margin-bottom: $main-padding;
}

.Footer {
  grid-area: footer;
}

.Title {
  color: $main-color;
}

.Details .Category {
  color: $secondary-color;
  margin-right: 10px;
}

.From {
  margin-top: 10px;
}

.Nice {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;

  img {
    border-radius: 10px;
    max-width: 100%;
  }
}

.NiceVertical {
  display: none;
}

.NiceHorizontal {
  display: block;
}

.MainImage {
  position: relative;
  max-width: 100%;
  height: 450px;

  .Placeholder {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.From {
  @mixin smallFont;
  display: flex;
  align-items: center;

  > * {
    margin-right: 5px;
  }
}

.Body {
  padding-top: $main-padding;

  @mixin paragraph;
}

.Bottom {
  margin-bottom: $main-padding;

  h4 {
    margin-bottom: 10px;
  }
}

.OtherArticle {
  margin-bottom: $main-padding;
}

.StickyContent {
  position: sticky;
  top: calc($header-height + $main-padding);
}

.Wrapper {
  padding: 0 $main-padding;
  display: grid;
  grid-gap: 1em;
  grid-template-columns: auto;
  grid-template-areas:
    'header'
    'left-sidebar'
    'content'
    'right-sidebar'
    'footer';
}

@media (--medium) {
  .NiceVertical {
    display: block;
  }

  .NiceHorizontal {
    display: none;
  }

  .Wrapper {
    grid-template-columns: 20% auto;
    grid-template-areas:
      'header   header'
      'left-sidebar  content'
      'right-sidebar right-sidebar'
      'footer footer';
  }
}

@media (--big) {
  .Wrapper {
    grid-gap: 20px;
    grid-template-columns: 200px 3fr 1fr;
    grid-template-areas:
      'header  header  header'
      'left-sidebar content right-sidebar'
      'footer  footer  footer';
  }
}
</style>

<style>
.lightbox__thumbnail {
  position: absolute;
  top: 0;
  left: 0;
  transition: 0.3s ease;
}

.lightbox__thumbnail img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}

.lightbox {
  z-index: 2;
}
</style>
